import angular from 'angular';
import _ from 'lodash';

(function() {
  'use strict';
  angular.module('app.core').factory('InvoiceEvent', InvoiceEventData);

  InvoiceEventData.$inject = ['$translate', 'logger', 'UtilSvc'];

  /* @ngInject */
  function InvoiceEventData($translate, logger, UtilSvc) {
    InvoiceEvent.prototype = {
      build: build,
      getEventLabel: getEventLabel,
      getEventComment: getEventComment
    };

    function InvoiceEvent(InvoiceEventData) {
      if (InvoiceEventData) {
        this.build(InvoiceEventData);
      }
    }

    return InvoiceEvent;

    /////////////////////

    function build(InvoiceEventData) {
      if (InvoiceEventData) {
        this.author = InvoiceEventData.author || null;
        this.name = InvoiceEventData.event || null;
        this.date = UtilSvc.parseDate(InvoiceEventData.date);
        this.eventComment = InvoiceEventData.eventComment || null;
        this.eventErrorMessages = InvoiceEventData.eventErrorMessages || null;
      } else {
        logger.error('Error with InvoiceEvent', InvoiceEventData);
      }
    }

    /**
     * Récupère le label traduit de l'evenement
     */
    function getEventLabel() {
      if (this.event) {
        return $translate.instant('invoices.status.' + angular.lowercase(this.event));
      }
      return '';
    }

    function getEventComment() {
      var label = [];
      if (this.statusComment) {
        label.push(this.statusComment);
      }

      if (this.statusErrorMessages) {
        label = label.concat(this.statusErrorMessages);
      }

      // Supprime les doublons (il se peut que le commentaire soit identique au message d'erreur)
      return _.uniq(label);
    }
  }
})();
